import { message as $message } from 'antd'

import {
    SiteConfigResType,
    updateSiteSwitch,
    updateConfig,
    openGetCompanySiteConfig,
    getCompanySiteConfig,
    DlzModelInfo,
    DlzModelCompanyContactInfo,
    ContactForCompanySiteRes,
    getContactForCompanySite
} from '@/services/dlz'
import { getInviteCoId, getInviteCoIdOpen } from '@/services/businessDynamics'
import { savePartnerInviteUrl, setPartnerInviteId } from '@/modules/dlz/helper'

const defaultInfo: DlzModelInfo = {
    coId: '',
    configJson: null,
    enabled: false,
    id: '',
    siteCode: '',
    siteDomain: '',
    siteLogo: ''
}

const defaultCompanyContactInfo: DlzModelCompanyContactInfo = {
    address: {
        address: '',
        rootAddress: []
    },
    weiXinNum: '',
    contactQr: '',
    phone: '',
    coName: ''
}

// mx8 本地域名
// const testDomain = 'testpinpai-l9s8o6xi.scm121.com'

// mx3
const testDomain = 'testpinpai-cfw5bdko.scm121.com'
// mx3 uat
// const testDomain = 'uatpinpai-cfw5bdko.scm121.com'

// mx5
// const testDomain = 'testpinpai-5ctowcrd.scm121.com'

// mx1
// const testDomain = 'testpinpai-etp949vp.scm121.com'

// 五星
// const testDomain = 'testpinpai-vj4snrmu.scm121.com'

// mx7 本地域名
// const testDomain = 'testpinpai-or3ss1mk.scm121.com'
// const testDomain = 'prepinpai-dapawjta.scm121.com'

const DlzModel = {
    namespace: 'dlz',
    state: {
        info: defaultInfo,
        companyContactInfo: defaultCompanyContactInfo,
        inviteInfo: {}
    },
    effects: {
        *fetchConfig({ payload }, { call, put }) {
            const { onCallback } = payload || {}
            let res: SiteConfigResType = {
                success: false,
                message: '',
                data: defaultInfo
            }
            if (window.TERMINANAME_IS_DLZ) {
                let domain = window.location.host
                if (window.PROJECT_CONFIG.mode === 'dev') {
                    domain = testDomain
                }

                res = yield call(openGetCompanySiteConfig, { siteDomain: domain })
            } else {
                res = yield call(getCompanySiteConfig)
            }
            const { success, message, data } = res ?? {}
            if (success) {
                onCallback?.(data)

                yield put({
                    type: 'update',
                    payload: {
                        info: data || {}
                    }
                })
            } else {
                $message.error(message)
            }
        },
        *fetchCompanyContact(_, { call, put }) {
            let res: ContactForCompanySiteRes = {
                success: false,
                message: '',
                data: defaultCompanyContactInfo
            }
            if (window.TERMINANAME_IS_DLZ) {
                let domain = window.location.host
                if (window.PROJECT_CONFIG.mode === 'dev') {
                    domain = testDomain
                }

                res = yield call(getContactForCompanySite, { siteDomain: domain })
            }
            const { success, message, data } = res ?? {}
            if (success) {
                yield put({
                    type: 'update',
                    payload: {
                        companyContactInfo: data
                    }
                })
            } else {
                $message.error(message)
            }
        },
        *updateSiteSwitch({ enabled }, { call, select }) {
            const siteCode: string = yield select(state => state.dlz.info.siteCode)

            let temp = {
                enabled
            }

            if (siteCode) {
                temp.siteCode = siteCode
            }
            const res: API.RootObject<boolean> = yield call(updateSiteSwitch, temp)

            const { success, message } = res ?? {}
            if (success) {
                return true
            } else {
                $message.error(message)
                return false
            }
        },
        *updateSiteConfigJson({ configJson }, { call, select }) {
            const siteCode: string = yield select(state => state.dlz.info.siteCode)

            const res: API.RootObject<boolean> = yield call(updateConfig, {
                configJson,
                siteCode
            })

            const { success, message } = res ?? {}
            if (success) {
                return true
            } else {
                $message.error(message)
                return false
            }
        },
        *updateSiteLogo({ siteLogo }, { call, select }) {
            const siteCode: string = yield select(state => state.dlz.info.siteCode)
            const res: API.RootObject<boolean> = yield call(updateConfig, {
                siteLogo,
                siteCode
            })

            const { success, message } = res ?? {}
            if (success) {
                return true
            } else {
                $message.error(message)
                return false
            }
        },
        *fetchInviteInfo({ payload }, { call, put }) {
            const { inviteId, supplierId, open, inviteType } = payload || {}
            if (!inviteId && !supplierId) {
                yield put({
                    type: 'update',
                    payload: {
                        inviteInfo: {}
                    }
                })
                return
            }

            let res = {}
            if (open) {
                res = yield call(getInviteCoId, { inviteId, supplierId })

                savePartnerInviteUrl(inviteId, inviteType)
            } else {
                res = yield call(getInviteCoIdOpen, { inviteId, supplierId })
                // 未登录状态下, 持久化合伙人推广信息
                if (inviteType === 'PARTNER') {
                    setPartnerInviteId(res?.data?.supplierCoId, inviteId)
                }
            }
            const { success, message, data } = res ?? {}
            if (success) {
                yield put({
                    type: 'update',
                    payload: {
                        inviteInfo: data || {}
                    }
                })
            } else {
                $message.error(message)
            }
        }
    },
    reducers: {
        update(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        }
    }
}

export default DlzModel
